.a5{width:100%;}